import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, CalendarDays, Coins, ShoppingBag } from "lucide-react";
import { useShop } from "@/context/ShopContext";

const TABS = [
  ["/", "Home", Home, "tab-home"],
  ["/catalogo", "Catalogo", LayoutGrid, "tab-catalog"],
  ["/eventi", "Eventi", CalendarDays, "tab-events"],
  ["/vendi", "Vendi", Coins, "tab-sell"],
];

export const MobileTabBar = () => {
  const { cartCount, setCartOpen } = useShop();
  const cls = "flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] font-semibold";
  return (
    <nav className="fixed inset-x-0 bottom-0 z-50 flex border-t-2 border-black bg-[#FFFBF3]/95 pb-[env(safe-area-inset-bottom)] backdrop-blur sm:hidden" data-testid="mobile-tab-bar">
      {TABS.map(([to, label, Icon, testid]) => (
        <NavLink key={to} to={to} end={to === "/"} data-testid={testid}
          className={({ isActive }) => `${cls} ${isActive ? "text-amber-600" : "text-stone-700"}`}>
          <Icon className="h-5 w-5" />{label}
        </NavLink>
      ))}
      <button onClick={() => setCartOpen(true)} className={`${cls} relative text-stone-700`} data-testid="tab-cart">
        <ShoppingBag className="h-5 w-5" />Carrello
        {cartCount > 0 && <span className="absolute right-[22%] top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-amber-500 px-1 text-[10px] text-black">{cartCount}</span>}
      </button>
    </nav>
  );
};
